import { CommonModule } from "@angular/common";
import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HotToastService } from "@ngneat/hot-toast";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";
import { ConversationsService } from "src/app/dashboard/conversations/conversations.service";
import { IConversation } from "src/app/dashboard/conversations/panels/conversation.model";

@Component({
    selector: "app-batch-action-message",
    imports: [CommonModule, FormsModule],
    templateUrl: "./batch-action-message.component.html",
    styleUrl: "./batch-action-message.component.scss"
})
export class BatchActionMessageComponent implements OnInit, OnDestroy {
  @Input() conversations: IConversation[];
  public onClose: Subject<boolean>;
  message: string = "";

  public constructor(
    public bsModalRef: BsModalRef,
    private conversationsService: ConversationsService,
    private toastr: HotToastService
  ) {}

  ngOnInit(): void {
    this.onClose = new Subject();
  }

  ngOnDestroy(): void {
    this.message = "";
  }

  async sendMessage() {
    const response = await this.conversationsService.sendMessageFromBatchAction(
      this.message,
      this.conversations
    );
    const toastrType = response.e ? "error" : "success";
    this.toastr[toastrType](response.message);
  }

  async confirm() {
    await this.sendMessage();
    this.bsModalRef.hide();
    this.onClose.next(true);
  }

  cancel() {
    this.bsModalRef.hide();
    this.onClose.next(false);
  }
}
